import { IExport, useImportedFilesQuery } from "../services/CostPlanService";
import { IField, Params } from "../types/table/interfaces.type";
import Actions from "./common/Actions";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import ErrorIcon from "@mui/icons-material/Error";
import { useState } from "react";
import CustomTable from "./common/table/CustomTable";
import {
  ExportAttachmentApi,
  IErrors,
} from "../services/ExportService";
import { Box, Tooltip } from "@mui/material";
import CustomLabel from "./common/CustomLabel";
import { hasJwtPermission } from "../services/ServicesHelpers";
interface ExportTableProps {
  usedBy: string;
  onRequestDialogControl?: () => () => void;
  onCloseImportDialog?: () => void; // Add this prop
}

interface ExportTableProps {
  usedBy: string;
  onView?: (exportData: IExport) => void;
}

const ExportTable: React.FC<ExportTableProps> = ({
  usedBy,
  onView,
  onCloseImportDialog,
}) => {
  const [appliedFilters] = useState<Params<IExport>>({
    usedBy,
  });

  const actions = Actions({
    onExportAttem: {
      handler: (row: any) => {
        console.log(" atteem ", row);
        ExportAttachmentApi(row.attachmentId, row.usedBy);
      },
      isDisabled: !hasJwtPermission(usedBy === "OPERATOR" ? "DOWNLOAD_OPERATOR_FILE" : "DOWNLOAD_OPERATOR_PREFIX_FILE"),
    },
    onView: {
      handler: (row: any) => {
        if (onView) {
          onView(row);
          if (onCloseImportDialog) {
            onCloseImportDialog();
          }
        }
      },
      isDisabled: !hasJwtPermission(usedBy === "OPERATOR" ? "GET_ALL_OPERATOR_IMPORT_ERRORS" : "GET_ALL_OPERATOR_PREFIX_IMPORT_ERRORS"),
    },
  });
  const fields: IField<IExport>[] = [
    { key: "fileName", header: "File Name" },
    { key: "createdBy", header: "Created By" },
    { key: "createdDate", header: "Created Date" },
    {
      key: "status",
      header: "Status",
      transform: (row: IExport) => {
        switch (row.status?.toLowerCase()) {
          case "success":
            return (
              <Tooltip title="Full Import succeeded">
                <CheckCircleIcon sx={{ color: "green" }} />
              </Tooltip>
            );
          case "fail":
          case "failed":
            return (
              <Tooltip title="All entries failed">
                <CancelIcon sx={{ color: "red" }} />
              </Tooltip>
            );
          case "pending":
            return (
              <Tooltip title="Pending">
                <HourglassEmptyIcon sx={{ color: "orange" }} />
              </Tooltip>
            );
          case "errors":
            return (
              <Tooltip title="Errors occurred">
                <ErrorIcon sx={{ color: "darkorange" }} />
              </Tooltip>
            );
          default:
            return row.status;
        }
      },
    },
  ];

  const ErrorField: IField<IErrors>[] = [
    { key: "rowNumber", header: "Row Number" },
    { key: "errorMessage", header: "Error Message" },
    { key: "createdBy", header: "Created By" },
    { key: "createdDate", header: "Created Date" },
  ];

  return (
    <>
      <Box
        mt={3}
        display="flex"
        justifyContent="flex-start"
        alignItems="center"
      >
        <CustomLabel
          text={
            usedBy === "OPERATOR"
              ? "Operator Sessions List"
              : "Prefixes Sessions List"
          }
          variant={"h5"}
          fontWeight={500}
        />
      </Box>
      <CustomTable<IExport>
        filters={appliedFilters}
        fields={fields}
        fetchFunc={useImportedFilesQuery}
        actions={actions}
        sortableFields={["status", "createdDate", "createdBy"]}
      />
    </>
  );
};

export default ExportTable;
